







export default {
  props: {
    /**
     * The background colour of the tile.
     */
    color: String,

    /**
     * The length and width of the tiles in pixels
     */
    size: Number,
  },
};
